export default {
  sousEtapesPro: [
    {
      nom: "raison-sociale",
      question: "Pour quelle Entreprise (raison sociale ou SIREN) souhaitez-vous comparer les offres d'énergie ?",
    },
    {
      nom: "nature",
      question: "",
    },
    {
      nom: "confirmation-nature",
      question: "Merci de nous confirmer la nature de votre structure",
    },
    {
      nom: "energie",
      question: "Pour quel type d’énergie souhaitez-vous comparer les offres ?",
    },
    {
      nom: "factures",
      question: "Téléverser ma derniere facture",
    },
    {
      nom: "objet-demande",
      question: "Merci de nous indiquer la raison de cette mise en concurrence énergie",
    },
    {
      nom: "compteurs",
      question: "Merci de préciser le périmètre de votre comparaison",
    },
    {
      nom: "mise-en-service",
      question: "Informations de mise en service",
    },
    {
      nom: "accord-grd",
      question: "Accord de collecte des données techniques et de consommation des points de livraison",
    },
    {
      nom: "vos-informations",
      question: "Merci de nous communiquer vos coordonnées",
    },
    {
      nom: "confidentialite",
      question: "",
    },
    {
      nom: "est-commande-publique",
      question: "Votre entreprise est-elle soumise au Code de la Commande Publique ?",
    },
  ],
  sousEtapesParticulier: [
    "particulier",
  ],
}
